import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {
    sublocalidades: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_SUBLOCALIDADES = 'GET_SUBLOCALIDADES'
const GET_SUBLOCALIDADES_BY_ID = 'GET_SUBLOCALIDADES_BY_ID'
const GET_SUBLOCALIDADES_BY_ID_LOCALIDAD = 'GET_SUBLOCALIDADES_BY_ID_LOCALIDAD'
const INSERT_SUBLOCALIDAD = 'INSERT_SUBLOCALIDAD'
const UPDATE_SUBLOCALIDAD = 'UPDATE_SUBLOCALIDAD'
const DELETE_SUBLOCALIDAD = 'DELETE_SUBLOCALIDAD'

//*******************************************************************************************************************


//METODOS
export const getSublocalidades = createAsyncThunk(
    GET_SUBLOCALIDADES,
    async () => {
        try {
            const fullUrl = host + `SubLocalidades/obtenerSubLocalidades`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const getSublocalidadesByIdLocalidad = createAsyncThunk(
    GET_SUBLOCALIDADES_BY_ID_LOCALIDAD,
    async (idLocalidad) => {
        try {
            //console.log('Estoy en el get de Sublocalidades de la localidad:'+idLocalidad)
            const fullUrl = host + `SubLocalidades/obtenerSubLocalidadesByIdLocalidad/${idLocalidad}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const getSublocalidadesById = createAsyncThunk(
    GET_SUBLOCALIDADES_BY_ID,
    async (idLocalidad) => {
        try {
            const fullUrl = host + `SubLocalidades/obtenerSubLocalidadById/${idLocalidad}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const insertSublocalidad = createAsyncThunk(
    INSERT_SUBLOCALIDAD,
    async (data) => {
        try {
            console.log(JSON.stringify(data))
            const fullUrl = host + `SubLocalidades/agregarSubLocalidad`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const updateSublocalidad = createAsyncThunk(
    UPDATE_SUBLOCALIDAD,
    async (data) => {
        try {
            const fullUrl = host + `SubLocalidades/actualizarSubLocalidad`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const deleteSublocalidad = createAsyncThunk(
    DELETE_SUBLOCALIDAD,
    async (idSublocalidad) => {
        try {
            const fullUrl = host + `SubLocalidades/eliminarSubLocalidad/${idSublocalidad}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


//****************************************************************************************************************
//EXPORTS DE MÉTODOS

export const metodosSublocalidadSlice = createSlice({

    name: 'metodosSublocalidadSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getSublocalidades.fulfilled]: (state, { payload }) => {
            state.sublocalidades = payload.data.data
        },

        [getSublocalidadesByIdLocalidad.fulfilled]: (state, { payload }) => {
            state.sublocalidades = payload.data.data
        },

        [getSublocalidadesById.fulfilled]: (state, { payload }) => {
            state.sublocalidades = payload.data.data
        },

        [insertSublocalidad.fulfilled]: (state, { payload }) => {
        },

        [updateSublocalidad.fulfilled]: (state, { payload }) => {
        },
        [deleteSublocalidad.fulfilled]: (state, { payload }) => {
        }
    },

})

export const { } = metodosSublocalidadSlice.actions
export const SublocalidadReducer = metodosSublocalidadSlice.reducer